module.exports = __webpack_public_path__ + "static/media/wcc_brand_w.1b0ab40a.png";